module.exports = __webpack_public_path__ + "img/1-4.ef7d36a7.png";